interface fetchHandlerArgs {
  fetchOptions: RequestInit;
  url: string;
  queryString?: string;
  data: APIData;
}

const handlePOST = async <T>({
  fetchOptions,
  url,
  queryString,
  data
}: fetchHandlerArgs): Promise<iResponse<T>> => {
  // Attach body to request
  fetchOptions.body = JSON.stringify(data);

  // Attach all parameters to queryable string;
  if (queryString) url = `${url}?${queryString}`;

  // Call the fetch function and parse as JSON
  const request: Response = await fetch(url, fetchOptions);
  const responseData = await request.json();

  if (request.status >= 400) {
    const response: iResponse<T> = {
      code: request.status,
      error: responseData as ResponseErrorObj
    };
    return response;
  } else {
    const response: iResponse<T> = {
      data: responseData,
      code: request.status
    };
    return response;
  }
};

export default handlePOST;
